import { GET_MUSICAL_FAMILIES } from "constants/musicalFamilies";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_MUSICAL_FAMILIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
